import React   from 'react';
import { Marker } from 'react-google-maps';
import icon from './../img/current-pin.png';

export default (props) => {
    let iconMarker = { url: icon, scaledSize: { width: 20, height: 20 } };
    return (
        <Marker
                position={{ lat: props.lat, lng: props.lng }}
                icon={ iconMarker } 
                 />
    )
}